var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42 1.86588L8.3325 2.97471C9.63 3.77765 10.5 5.22294 10.5 6.88235C10.5 8.09923 10.0259 9.26626 9.18198 10.1267C8.33807 10.9872 7.19347 11.4706 6 11.4706C4.80653 11.4706 3.66193 10.9872 2.81802 10.1267C1.97411 9.26626 1.5 8.09923 1.5 6.88235C1.5 5.22294 2.37 3.77765 3.66 2.96706L2.58 1.86588C1.02 2.96706 0 4.80235 0 6.88235C0 8.50485 0.632141 10.0609 1.75736 11.2082C2.88258 12.3555 4.4087 13 6 13C7.5913 13 9.11742 12.3555 10.2426 11.2082C11.3679 10.0609 12 8.50485 12 6.88235C12 4.80235 10.98 2.96706 9.42 1.86588ZM6.75 0H5.25V7.64706H6.75",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogoutWhite);
export default __webpack_public_path__ + "static/media/ico-logout-white.2d8f360ed35e26611cfd0b2aef1d57ed.svg";
export { ForwardRef as ReactComponent };